import useGetApi from 'src/api/useGetApi';
import { SalesOrderDraft } from 'src/types/application/SalesOrderDraftDTO';
import type { FieldEntry } from '@erp/shared-types';

/** Features that control validation behavior for sales order drafts */
export interface SalesOrderDraftFeatures {
  inventoryValidation: boolean;
  discountValidation: boolean;
  requestDateCalculation: boolean;
}

/** Approval flow behavior flags for sales order drafts */
export interface SalesOrderDraftApprovalFlow {
  softIssuesEnabled: boolean;
  requiresAssignee: boolean;
}

type ApiResponse = {
  stagedPurchaseOrder: SalesOrderDraft;
  /** Header fields from UiFieldResolutionService */
  headerFields?: FieldEntry[];
  /** Line item fields from UiFieldResolutionService (controls table columns) */
  lineItemFields?: FieldEntry[];
  /** Feature flags for validation behavior */
  features: SalesOrderDraftFeatures;
  /** Approval flow configuration */
  approvalFlow: SalesOrderDraftApprovalFlow;
};

const useSalesOrderDraft = (salesOrderDraftId: string) => {
  return useGetApi<ApiResponse>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}`,
    options: {
      enabled: !!salesOrderDraftId,
    },
  });
};

export default useSalesOrderDraft;
